import {Component, input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";


@Component({
    selector: 'app-empty-alert-message',
    templateUrl: './app-empty-alert-message.component.html',
    styleUrls: ['./app-empty-alert-message.component.scss'],
    standalone: true,
    imports: [
        TranslateModule
    ]
})
export class AppEmptyAlertMessageComponent {
    show = input<Boolean>(false);
    shortMessage = input<Boolean>(false);
    containerClass = input<string>('');
}
